module.exports = __webpack_public_path__ + "media/images/home-soccermom-2-e2bdeac165f2a524405f1aca1b4b887e.jpg";